import React, { useEffect, useState } from "react";
import { reduxForm } from "redux-form";
import Title from "../../Utils/Headers/Title";
import Filters from "../../Utils/Filters/Filters";
import {
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Table,
    Spinner
} from "reactstrap";
import classnames from "classnames";

import "./report-region.css";

import "./report-region.css";

const List = ({
    listarReport,
    data,
    loader,
    descargarExcel,
    descargarExcelV2,
    start_date,
    setStartDate,
    end_date,
    setEndDate,
    region,
    setRegion,
    show_patients,
    setShowPatients,
    excelLoading,
    excelLoadingV2,
}) => {
    const [activeTab, setActiveTab] = useState(0);
    const [expanded, setExpanded] = useState({});
    const [currentPage, setCurrentPage] = useState(1);
    const categoriesPerPage = 10;

    useEffect(() => {
        listarReport();
    }, []);

    const toggleTab = (tab) => {
        if (activeTab !== tab) {
            setActiveTab(tab);
            setCurrentPage(1);
        }
    };

    const toggleCategory = (regionIndex, catIndex) => {
        const key = `${regionIndex}-${catIndex}`;
        setExpanded(prev => ({
            ...prev,
            [key]: prev[key] === undefined ? false : !prev[key]
        }));
    };

    const isExpanded = (regionIndex, catIndex) => {
        const key = `${regionIndex}-${catIndex}`;
        return expanded[key] !== false; // Default to true (expanded)
    };

    const renderPagination = (currentPage, totalPages, setCurrentPage) => {
        let startPage = Math.max(1, currentPage - 2);
        let endPage = Math.min(totalPages, currentPage + 2);

        if (endPage - startPage < 4) {
            if (startPage === 1) {
                endPage = Math.min(totalPages, 5);
            } else if (endPage === totalPages) {
                startPage = Math.max(1, totalPages - 4);
            }
        }

        const pages = [];
        for (let i = startPage; i <= endPage; i++) {
            pages.push(i);
        }

        return (
            <ul className="pagination pagination-sm mb-0 flex-wrap justify-content-center custom-pagination-chips">
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(1)}>Primero</button>
                </li>
                <li className={`page-item ${currentPage === 1 ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.max(prev - 1, 1))}>Anterior</button>
                </li>
                {pages.map(page => (
                    <li key={page} className={`page-item ${currentPage === page ? 'active' : ''}`}>
                        <button className="page-link" onClick={() => setCurrentPage(page)}>{page}</button>
                    </li>
                ))}
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(prev => Math.min(prev + 1, totalPages))}>Siguiente</button>
                </li>
                <li className={`page-item ${currentPage === totalPages ? 'disabled' : ''}`}>
                    <button className="page-link" onClick={() => setCurrentPage(totalPages)}>Último</button>
                </li>
            </ul>
        );
    };

    return (
        <div className="py-4">
            <div className="row">
                <div className="mb-4 col-lg-12">
                    <div className="card card-report-region border-0 shadow-sm">
                        <div className="card-header bg-white border-0 px-4 pt-4 pb-0">
                            <h3 className="font-weight-bold" style={{ color: "#1E2A41", fontSize: "1.5rem" }}>Reporte Regional</h3>
                            <h6 className="text-muted mb-0" style={{ fontWeight: 500 }}>Desglose por Pestañas</h6>
                        </div>
                        <div className="card-body px-4 pb-0">
                            <div className="filters-container-rrhh mb-4">
                                <div className="filters-fields-group">
                                    <Filters
                                        startDate={{
                                            show: true,
                                            isRange: true,
                                            start_date: start_date,
                                            setStartDate: setStartDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        endDate={{
                                            show: true,
                                            end_date: end_date,
                                            setEndDate: setEndDate,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "calendar_today",
                                        }}
                                        region={{
                                            show: true,
                                            region: region,
                                            filterByRegion: setRegion,
                                            classNameFilter: "flex-1 filter-wrapper",
                                            icon: "public",
                                        }}
                                    />
                                </div>
                                <div className="filters-actions-group">
                                    <div className="custom-control custom-switch">
                                        <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            id="showPatientsSwitch"
                                            checked={show_patients !== false}
                                            onChange={(e) => setShowPatients(e.target.checked)}
                                        />
                                        <label className="custom-control-label font-weight-bold" htmlFor="showPatientsSwitch" style={{ color: "#1E2A41", cursor: "pointer", paddingTop: "2px" }}>
                                            Columna Pctes.
                                        </label>
                                    </div>
                                    {/* Version A */}
                                    <button
                                        id="btn-exportar-excel-va"
                                        className="btn font-weight-bold d-flex align-items-center outline-none"
                                        style={{ backgroundColor: "#e0e7ff", color: "#3b82f6", borderRadius: "30px", padding: "10px 20px", transition: "all 0.2s", fontSize: "13px", border: "none" }}
                                        onClick={descargarExcel}
                                        disabled={excelLoading}
                                        title="Exportar reporte completo con todos los subtipos (Versión A)"
                                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#c7d2fe"; }}
                                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#e0e7ff"; }}
                                    >
                                        {excelLoading ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            <span className="material-icons" style={{ fontSize: "16px" }}>insert_drive_file</span>
                                        )}
                                        <span className="ml-2">{excelLoading ? 'Generando...' : 'Excel (V.A)'}</span>
                                    </button>
                                    {/* Version B */}
                                    <button
                                        id="btn-exportar-excel-vb"
                                        className="btn font-weight-bold d-flex align-items-center outline-none"
                                        style={{ backgroundColor: "#d1fae5", color: "#059669", borderRadius: "30px", padding: "10px 20px", transition: "all 0.2s", fontSize: "13px", border: "none" }}
                                        onClick={descargarExcelV2}
                                        disabled={excelLoadingV2}
                                        title="Versión B: Heridos/Accidentes consolidados, Fallecidos en 1 fila, Incendios con prefijo"
                                        onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#a7f3d0"; }}
                                        onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#d1fae5"; }}
                                    >
                                        {excelLoadingV2 ? (
                                            <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                        ) : (
                                            <span className="material-icons" style={{ fontSize: "16px" }}>table_chart</span>
                                        )}
                                        <span className="ml-2">{excelLoadingV2 ? 'Generando...' : 'Excel (V.B)'}</span>
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="p-0 px-4 pb-4">
                            {loader ? (
                                <div className="text-center py-5">
                                    <Spinner color="primary" />
                                    <p className="mt-2 text-muted font-weight-bold">Cargando datos regionales...</p>
                                </div>
                            ) : data && data.length > 0 ? (
                                <div>
                                    <Nav tabs className="border-bottom-0 pb-3" style={{ borderBottom: '1px solid #e0e7ff' }}>
                                        {data.map((r, idx) => (
                                            <NavItem key={idx}>
                                                <NavLink
                                                    className={classnames({ active: activeTab === idx })}
                                                    onClick={() => { toggleTab(idx); }}
                                                    style={{
                                                        cursor: "pointer",
                                                        fontWeight: activeTab === idx ? "bold" : "normal",
                                                        color: activeTab === idx ? "#3b82f6" : "#6b7280",
                                                        border: "none",
                                                        borderBottom: activeTab === idx ? "3px solid #3b82f6" : "3px solid transparent",
                                                        backgroundColor: "transparent",
                                                        padding: "10px 20px"
                                                    }}
                                                >
                                                    Región {r.region_name}
                                                </NavLink>
                                            </NavItem>
                                        ))}
                                    </Nav>
                                    <TabContent activeTab={activeTab} className="pt-4">
                                        {data.map((r, idx) => (
                                            <TabPane tabId={idx} key={idx}>
                                                <div className="table-responsive shadow-sm" style={{ borderTopLeftRadius: "8px", borderTopRightRadius: "8px", overflowX: "auto" }}>
                                                    <Table bordered hover size="sm" className="mb-0 custom-report-table bg-white">
                                                        <thead>
                                                            <tr style={{ backgroundColor: "#95B3D7", color: "#1E2A41" }}>
                                                                <th className="align-middle text-center font-weight-bold" rowSpan="2" style={{ width: "300px", borderBottom: '2px solid #ddd' }}>DESCRIPCIÓN</th>
                                                                {r.stations.map((s, sIdx) => (
                                                                    <th key={sIdx} colSpan={show_patients !== false ? "2" : "1"} className="text-center font-weight-bold align-middle" style={{ backgroundColor: "#B8CCE4", borderBottom: '2px solid #ddd' }}>{s.name}</th>
                                                                ))}
                                                                <th colSpan={show_patients !== false ? "2" : "1"} className="text-center font-weight-bold align-middle" style={{ backgroundColor: "#8CD3DA", borderBottom: '2px solid #ddd' }}>TOTALES</th>
                                                            </tr>
                                                            <tr style={{ backgroundColor: "#B8CCE4", color: "#1E2A41" }}>
                                                                {r.stations.map((s, sIdx) => (
                                                                    <React.Fragment key={sIdx}>
                                                                        <th className="text-center" style={{ borderBottom: '2px solid #ddd' }}>Emerg.</th>
                                                                        {show_patients !== false && <th className="text-center" style={{ borderBottom: '2px solid #ddd' }}>Pacien.</th>}
                                                                    </React.Fragment>
                                                                ))}
                                                                <th className="text-center" style={{ backgroundColor: "#8CD3DA", borderBottom: '2px solid #ddd' }}>Emerg.</th>
                                                                {show_patients !== false && <th className="text-center" style={{ backgroundColor: "#8CD3DA", borderBottom: '2px solid #ddd' }}>Pacien.</th>}
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {r.categories.slice((currentPage - 1) * categoriesPerPage, currentPage * categoriesPerPage).map((cat, cIdx) => {
                                                                const actualCIdx = (currentPage - 1) * categoriesPerPage + cIdx;
                                                                return (
                                                                    <React.Fragment key={actualCIdx}>
                                                                        <tr
                                                                            style={{ backgroundColor: "#FFFF00", color: "#333", cursor: "pointer", transition: "background-color 0.2s" }}
                                                                            onClick={() => toggleCategory(idx, actualCIdx)}
                                                                            onMouseOver={(e) => { e.currentTarget.style.backgroundColor = "#E6E600"; }}
                                                                            onMouseOut={(e) => { e.currentTarget.style.backgroundColor = "#FFFF00"; }}
                                                                        >
                                                                            <td className="font-weight-bold px-3 py-2">
                                                                                <div className="d-flex align-items-center justify-content-between">
                                                                                    <span>{cat.category_name}</span>
                                                                                    <span className="material-icons text-muted" style={{ fontSize: "20px" }}>
                                                                                        {isExpanded(idx, actualCIdx) ? 'expand_less' : 'expand_more'}
                                                                                    </span>
                                                                                </div>
                                                                            </td>
                                                                            {r.stations.map((s, sIdx) => {
                                                                                const catStat = (cat.category_station_stats && cat.category_station_stats.find(st => st.station_id === s.id)) || { emergencies: 0, patients: 0 };
                                                                                return (
                                                                                    <React.Fragment key={sIdx}>
                                                                                        <td className="text-center align-middle font-weight-bold" style={{ color: catStat.emergencies > 0 ? '#1E2A41' : '#ccc' }}>
                                                                                            {catStat.emergencies > 0 ? catStat.emergencies : '-'}
                                                                                        </td>
                                                                                        {show_patients !== false && (
                                                                                            <td className="text-center align-middle font-weight-bold" style={{ color: catStat.patients > 0 ? '#1E2A41' : '#ccc' }}>
                                                                                                {catStat.patients > 0 ? catStat.patients : '-'}
                                                                                            </td>
                                                                                        )}
                                                                                    </React.Fragment>
                                                                                );
                                                                            })}
                                                                            <td className="text-center align-middle font-weight-bold" style={{ color: cat.category_total_emergencies > 0 ? '#1E2A41' : '#ccc' }}>
                                                                                {cat.category_total_emergencies > 0 ? cat.category_total_emergencies : '-'}
                                                                            </td>
                                                                            {show_patients !== false && (
                                                                                <td className="text-center align-middle font-weight-bold" style={{ color: cat.category_total_patients > 0 ? '#1E2A41' : '#ccc' }}>
                                                                                    {cat.category_total_patients > 0 ? cat.category_total_patients : '-'}
                                                                                </td>
                                                                            )}
                                                                        </tr>
                                                                        {isExpanded(idx, actualCIdx) && cat.types.map((type, tIdx) => (
                                                                            <tr key={tIdx}>
                                                                                <td className="px-3 py-1 font-weight-normal text-muted">{type.type_name}</td>
                                                                                {type.station_stats.map((stat, stIdx) => (
                                                                                    <React.Fragment key={stIdx}>
                                                                                        <td className="text-center align-middle" style={{ color: stat.emergencies > 0 ? '#1E2A41' : '#ccc', fontWeight: stat.emergencies > 0 ? '600' : 'normal' }}>{stat.emergencies > 0 ? stat.emergencies : '-'}</td>
                                                                                        {show_patients !== false && <td className="text-center align-middle" style={{ color: stat.patients > 0 ? '#1E2A41' : '#ccc', fontWeight: stat.patients > 0 ? '600' : 'normal' }}>{stat.patients > 0 ? stat.patients : '-'}</td>}
                                                                                    </React.Fragment>
                                                                                ))}
                                                                                <td className="text-center align-middle" style={{ backgroundColor: "#f8f9fa", color: type.row_total_emergencies > 0 ? '#1E2A41' : '#ccc', fontWeight: type.row_total_emergencies > 0 ? 'bold' : 'normal' }}>{type.row_total_emergencies > 0 ? type.row_total_emergencies : '-'}</td>
                                                                                {show_patients !== false && <td className="text-center align-middle" style={{ backgroundColor: "#f8f9fa", color: type.row_total_patients > 0 ? '#1E2A41' : '#ccc', fontWeight: type.row_total_patients > 0 ? 'bold' : 'normal' }}>{type.row_total_patients > 0 ? type.row_total_patients : '-'}</td>}
                                                                            </tr>
                                                                        ))}
                                                                    </React.Fragment>
                                                                );
                                                            })}
                                                            <tr className="sticky-total-row" style={{ backgroundColor: "#1F497D", color: "white" }}>
                                                                <td className="font-weight-bold px-3 py-2">TOTAL GENERAL</td>
                                                                {r.stations.map((s, sIdx) => {
                                                                    let estEmerg = 0;
                                                                    let estPat = 0;
                                                                    r.categories.forEach(cat => {
                                                                        cat.types.forEach(type => {
                                                                            const stat = type.station_stats.find(st => st.station_id === s.id);
                                                                            if (stat) {
                                                                                estEmerg += stat.emergencies;
                                                                                estPat += stat.patients;
                                                                            }
                                                                        })
                                                                    });
                                                                    return (
                                                                        <React.Fragment key={sIdx}>
                                                                            <td className="text-center font-weight-bold py-2">{estEmerg > 0 ? estEmerg : '-'}</td>
                                                                            {show_patients !== false && <td className="text-center font-weight-bold py-2">{estPat > 0 ? estPat : '-'}</td>}
                                                                        </React.Fragment>
                                                                    );
                                                                })}
                                                                <td className="text-center font-weight-bold" style={{ backgroundColor: "#15355e" }}>
                                                                    {r.region_total_unique_emergencies || '-'}
                                                                </td>
                                                                {show_patients !== false && <td className="text-center font-weight-bold" style={{ backgroundColor: "#15355e" }}>
                                                                    {r.categories.reduce((acc, cat) => acc + cat.category_total_patients, 0) || '-'}
                                                                </td>}
                                                            </tr>
                                                        </tbody>
                                                    </Table>
                                                </div>
                                                {r.categories.length > categoriesPerPage && (
                                                    <div className="d-flex justify-content-center justify-content-md-end p-3 bg-white sticky-pagination" style={{ borderTop: "1px solid #e0e7ff", borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }}>
                                                        <nav>
                                                            {renderPagination(currentPage, Math.ceil(r.categories.length / categoriesPerPage), setCurrentPage)}
                                                        </nav>
                                                    </div>
                                                )}
                                            </TabPane>
                                        ))}
                                    </TabContent>
                                </div>
                            ) : (
                                <div className="text-center py-5 text-muted bg-light rounded shadow-sm border">
                                    <span className="material-icons mb-3" style={{ fontSize: "64px", opacity: 0.3 }}>assignment_late</span>
                                    <h4 className="font-weight-bold">No hay registros</h4>
                                    <p>Intenta ajustar los filtros de fechas o región para visualizar datos.</p>
                                </div>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default reduxForm({
    form: "ListRegionReport",
})(List);

